const config = {
  maintenanceMode: (window["env"] && (window["env"]["maintenanceMode"] === 'true' || window["env"]["maintenanceMode"] === true)) || false,
  apiUrl: (window["env"] && window["env"]["apiUrl"]) || "http://localhost:80/",
  sentryEnabled: (window["env"] && window["env"]["sentryEnabled"]) || false,
  sentryDns: (window["env"] && window["env"]["sentryDns"]) || "https://cd6b8eef02e3445a812ce6f903a22ccb@glitchtip.w4msolutions.com/5",
  sentryEnvironment: (window["env"] && window["env"]["sentryEnvironment"]) || "dev",
  sentryTracesSampleRate: (window["env"] && window["env"]["sentryTracesSampleRate"]) || 0.01,
};
export { config };
export default config;
